import { DELIVERY_CHALLAN_TRANSACTION_REQUEST, GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO, DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE,
  GET_DELIVERY_CHALLAN_TRANSACTIONS } from '../types';

const initialState = {
  transactions: [],
  takaNos: [],
  loading: false,
  error: null,
};

const deliveryChallanTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELIVERY_CHALLAN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default deliveryChallanTransactionReducer;
